import { DataLayerTransformer } from '../transformers/pixall/index.js';
const transformCoxAutoDataLayer = _ref => {
  let {
    listingType = 'lstg',
    cdl,
    dataLayer = {},
    eventType = 'click'
  } = _ref;
  // Add alpha zone data to srp, vdp events
  if (['alp', 'alp-dlr', 'alpm', 'alpm-dlr'].includes(listingType)) {
    const pageName = DataLayerTransformer.getPageName(dataLayer);
    let isAppliedCdl;
    switch (eventType) {
      case 'click':
      case 'page':
        isAppliedCdl = ['srp', 'vdp'].includes(pageName);
        break;
      case 'impression':
        isAppliedCdl = pageName === 'srp';
        break;
      default:
        isAppliedCdl = false;
    }
    if (isAppliedCdl) {
      cdl.advertising = dataLayer.matchAlphaZone;
    }
  }
};
export default transformCoxAutoDataLayer;